import { useTranslation } from '@packlink/translation-provider';
import { useCustomsFormContext } from '../../CustomsFormData.js';
import { getComposedFieldName } from '@packlink/utils';
import { FormField, Checkbox } from '@shipengine/formik-giger';
import { FastField } from 'formik';
import DOMPurify from 'dompurify';
import { useMemo } from 'react';
import { Typography } from '@shipengine/giger';
import { getLegalFormTitleStyles } from './LegalFormStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { CustomsSection } from '../Partials/CustomsSection.js';

function LegalForm(_ref) {
  let {
    supportLink,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    fieldNamePrefix
  } = useCustomsFormContext();
  const customsTermsLabel = useMemo(() => DOMPurify.sanitize(t('customs-form.legal-acceptance.terms-label', {
    link: supportLink
  }), {
    ADD_ATTR: ['target']
  }), [supportLink, t]);
  return jsxs(CustomsSection, {
    title: t('customs-form.legal-acceptance.title'),
    ...props,
    children: [jsx(Typography, {
      component: "p",
      css: getLegalFormTitleStyles,
      children: t('customs-form.legal-acceptance.introduction')
    }), jsx(FormField, {
      name: getComposedFieldName(fieldNamePrefix, 'customsTerms'),
      children: jsx(FastField, {
        component: Checkbox,
        label: jsx("span", {
          dangerouslySetInnerHTML: {
            __html: customsTermsLabel
          }
        })
      })
    }), jsx(FormField, {
      name: getComposedFieldName(fieldNamePrefix, 'authorised'),
      children: jsx(FastField, {
        component: Checkbox,
        label: t('customs-form.legal-acceptance.signature-label')
      })
    })]
  });
}

export { LegalForm };
//# sourceMappingURL=LegalForm.js.map
